import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Routes } from 'router/routes';
import ChildrenIcon from 'assets/img/icons/childs.svg?react';

import s from './styles.module.scss';

import type { Clinic } from 'infrastructure/classes/clinic';

interface IProps {
  data: Clinic;
  hideParentTag?: boolean;
}

const ClinicColumn: React.FC<IProps> = ({ data, hideParentTag }) => {
  const { t } = useTranslation();

  const isParent = !!data.childClinicsGuid.length;
  const isChild =
    Boolean(data?.parentClinicName) || Boolean(data?.parentClinicGuid);
  const parentClinicName = data?.parentClinicName ?? '';
  const isSingle = !isParent && !isChild;

  return (
    <Link
      data-cy="clinicListTable-clinic-link"
      to={Routes.adminClinic(data.guid)}
    >
      {isParent && (
        <div className={s['name-wrapper']}>
          <span className={s.parent} data-cy="clinicListTable-parentClinicTag">
            {t('labels.parentClinic')}
            <div className={s.count}>
              <ChildrenIcon width={15} height={15} />
              {data.childClinicsGuid.length}
            </div>
          </span>
          <span className={s.name}>{data.legalname}</span>
        </div>
      )}
      {isChild && (
        <div className={s['name-wrapper']}>
          <span className={s.child} data-cy="clinicListTable-parentClinic">
            {!hideParentTag && `${t('labels.parent')}: ${parentClinicName}`}
          </span>
          <span className={s.name}>{data.legalname}</span>
        </div>
      )}
      {isSingle && (
        <div className={s['name-wrapper']}>
          <span className={s.name}>{data.legalname}</span>
        </div>
      )}
    </Link>
  );
};

export default ClinicColumn;
